import React from 'react'
import { Grid } from '@mui/material'
import useTitles from 'common/hooks/useTitles'
import UptimeSlaCard from './UptimeSlaCard'
import Fail2banCard from './Fail2banCard'

// Tableau de bord Prod (stats pour le COPOL).
const DashboardProdApp = () => {
    useTitles(() => [{
        label: 'Tableau de bord Prod',
        href: '/dashboardProd',
    }], [])

    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <UptimeSlaCard />
            </Grid>
            <Grid size={12}>
                <Fail2banCard />
            </Grid>
        </Grid>
    )
}

export default DashboardProdApp
